// extracted by mini-css-extract-plugin
export default {"content":"Signature__content--Wj9Ef","label":"Signature__label--lRWmg","header":"Signature__header--ZhFRd","action":"Signature__action--HGcgT","error":"Signature__error--l6wmO"};